import axios from "axios";
import { API } from "../config/BackendUrl";
const tokenurl = `${API}/collection`;

export const collectionDeploy = async (data) => {
  const config = {
    method: "post",
    url: `${tokenurl}/deploy`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
    data: data,
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const collectionAdd = async (data) => {
  const config = {
    method: "post",
    url: `${tokenurl}/add`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
    data: data,
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getmarketItemOfCollection = async (collectionAddress) => {
  const config = {
    method: "get",
    url: `${tokenurl}/itemList/${collectionAddress}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return { status: 400 };
  }
};

export const getCollectionDetails = async (collectionAddress) => {
  const config = {
    method: "get",
    url: `${tokenurl}/Address/${collectionAddress}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getCollectionDetailsById = async (id) => {
  const config = {
    method: "get",
    url: `${tokenurl}/id/${id}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateCollectionDetailsById = async (id, body) => {
  const config = {
    method: "put",
    url: `${tokenurl}/id/${id}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
    data: body
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getCollectionListbyWalletAddress = async (query) => {
  const queryString = new URLSearchParams(query).toString();

  const config = {
    method: "get",
    url: `${tokenurl}/?${queryString}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getCollectionList = async () => {
  const config = {
    method: "get",
    url: `${tokenurl}/all`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getURIFromCollection = async (collectionAddress, tokenId) => {
  const config = {
    method: "get",
    url: `${tokenurl}/${collectionAddress}/uri/${tokenId}`,
    cors: "no-cors",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res;
  } catch (error) {
    return [];
  }
};

export const getHashFromCollection = async (collectionAddress, tokenId) => {
  const config = {
    method: "get",
    url: `${tokenurl}/${collectionAddress}/transaction/hash/${tokenId}`,
    cors: "no-cors",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res;
  } catch (error) {
    return [];
  }
};

export const getTransactionHistory = async (collectionAddress, tokenId) => {
  const config = {
    method: "get",
    url: `${tokenurl}/${collectionAddress}/transaction/history/${tokenId}`,
    cors: "no-cors",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res;
  } catch (error) {
    return [];
  }
};

export const getAirDropHistory = async (collectionAddress) => {
  const config = {
    method: "get",
    url: `${tokenurl}/${collectionAddress}/airdrop/history`,
    cors: "no-cors",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res;
  } catch (error) {
    return [];
  }
};

export const getAllCollectionListWithDetails = async (page, limit) => {
  const config = {
    method: "get",
    url: `${tokenurl}/collectionlist/details/all?page=${page}&limit=${limit}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getAllCollectionListWithWallet = async (
  walletAddress,
  page,
  limit
) => {
  console.log("walletAddress, page, limit", walletAddress, page, limit);
  const config = {
    method: "get",
    url: `${tokenurl}/User/Collection/list/all/${walletAddress}?page=${page}&limit=${limit}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
